<template>
    <v-container class="pb-0">
        <v-card
            flat
            class="px-6"
        >
            <v-data-table
                :items="markSheetRecordsFilter"
                :loading="loading"
                :headers="headers"
                :height="height"            
                fixed-header           
                class="enter-marks-table"
                disable-pagination
                hide-default-footer 
            >
                <template v-slot:item="props">
                    <Record
                        v-bind:studentRecord="props.item"
                        v-bind:formLevel="lessonSelected.formLevel"
                        v-bind:index="props.index"
                        v-bind:weightedExam="weightedExam"
                        v-bind:examMax="examMax"
                        v-bind:courseMax="courseMax"
                        v-on:error="displayDialogError"
                    />
                </template>
            </v-data-table>

            <v-dialog
                v-model="dialogError"
                persistent
                max-width="400"
            >
                <v-card>
                    <v-toolbar dark color="red" flat dense>
                        <v-toolbar-title class="text-h5">
                            <v-icon large left color="white">mdi-alert-circle</v-icon>
                            Error
                        </v-toolbar-title>
                    </v-toolbar>    
                    
                    <v-card-text class="mt-4">
                        An error has occured while saving the marks. Unable to save marks please contact the system administrator.
                        <div class="mt-4 red--text">{{ errorDetails }}</div>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="red"
                            @click="dialogError = false"
                            dark
                            depressed
                        >
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </v-container>
</template>

<script>
import Record from './EnterMarksSheetRecord';
import { mapGetters, mapMutations } from 'vuex';
export default {
    components: {
        Record,
    },
    
    data: () =>({
        loading: false,
        height: "45vh",
        pagination: false,
        footer: false,                
        headers: [],
        // table2RecordsFilter: [],
        weightedExam: false,
        dialogError: false,
        errorDetails: '',
        examMax: 100,
        courseMax: 100,
    }),

    computed:{
        ...mapGetters({            
            table2Records: 'termReports/getTable2Records',
            currentTerm: 'termReports/getCurrentTerm',
            lessonSelected: 'termReports/getLessonSelected',
            markSheetClassesFilter: 'termReports/getMarkSheetClassesFilter',
            markSheetRecordsFilter: 'termReports/getMarkSheetRecordsFilter',
            
        }),

    },
    watch: {
        
        table2Records: {
            handler () {
                this.initialize();
            }
        },

        markSheetClassesFilter: {
            handler () {
                this.getFilterTable2Records();
            }
        }
       
    },
    methods: { 
        ...mapMutations({
            setMarkSheetRecordsFilter: 'termReports/setMarkSheetRecordsFilter',
        }),

       initialize(){
            // this.table2RecordsFilter = [];
            // this.setMarkSheetRecordsFilter([]);
            // this.headers = [];
            this.weightedExam = false;

            this.headers = [
                {text: '', value: 'count', align: 'left', width: '45', sortable: false},
                {text: 'Name', value: 'name',  sortable: false},
                {text: 'Mid Term Exam', value: 'course', align: 'center', width: '100', sortable: false,},            
                {text: 'End of Term Exam', value: 'exam', align: 'center', width: '100', sortable: false,},    
                {text: 'Coded Comment 1', value: 'codedComment1', align: 'center', width: '100', sortable: false,},            
                {text: 'Coded Comment 2',  value: 'codedComment2', align: 'center', width: '100', sortable: false,},
                {text: ' ', value: 'actions', align: 'center', sortable: false, width: '40'},                        
            ]
            
            if(this.lessonSelected.formLevel >= 4){
                this.headers = [
                {text: '', value: 'count', align: 'left', width: '45', sortable: false},
                {text: 'Class', value: 'class_id', width: '70', sortable: false},
                {text: 'Name', value: 'name',  sortable: false},
                {text: 'Mid Term Exam', value: 'course', align: 'center', width: '100', sortable: false,},            
                {text: 'End of Term Exam', value: 'exam', align: 'center', width: '100', sortable: false,},    
                {text: 'Coded Comment 1', value: 'codedComment1', align: 'center', width: '100', sortable: false,},            
                {text: 'Coded Comment 2',  value: 'codedComment2', align: 'center', width: '100', sortable: false,},
                {text: ' ', value: 'actions', align: 'center', sortable: false, width: '40'},                        
            ]
            }

            this.$nextTick(() => {
                // this.table2RecordsFilter = JSON.parse(JSON.stringify(this.table2Records));
                this.setMarkSheetRecordsFilter(JSON.parse(JSON.stringify(this.table2Records)));
            })
        },
        
        getFilterTable2Records () {
            // this.table2RecordsFilter = [];
            const table2RecordsFilter = this.table2Records.filter( record =>  this.markSheetClassesFilter.includes(record.class_id) );
            this.setMarkSheetRecordsFilter(JSON.parse(JSON.stringify(table2RecordsFilter)));
        },

        displayDialogError (error) {
            if(error) this.errorDetails = error;
            this.dialogError = true;
        }
    }       
}
</script>

<style scoped>
    .v-text-field__slot textarea{
        font-size: 13px;
    }
    .v-data-table > .v-data-table__wrapper > table{
        table-layout: fixed;
    }
    th span{
        display: flex;
    }
    ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
        padding: 10px 6px;
    }
</style>